export const ORDER_SYNC_PASSWORD = "Sipadmin@123"; // Sync password for order data sync.

// ─── Enum → display label maps ───────────────────────────────────────────────

export const GENDER_LABEL: Record<string, string> = {
  M: "Male",
  F: "Female",
  O: "Other",
};

export const OCCUPATION_LABEL: Record<string, string> = {
  BUSINESS: "Business",
  SERVICE: "Service",
  PROFESSIONAL: "Professional",
  AGRICULTURIST: "Agriculturist",
  RETIRED: "Retired",
  HOUSEWIFE: "Housewife",
  STUDENT: "Student",
  OTHERS: "Others",
  DOCTOR: "Doctor",
  PRIVATE_SECTOR_SERVICE: "Private Sector Service",
  PUBLIC_SECTOR_SERVICE: "Public Sector Service",
  FOREX_DEALER: "Forex Dealer",
  GOVERNMENT_SERVICE: "Government Service",
  UNKNOWN_NOT_APPLICABLE: "Not Applicable",
};

export const WEALTH_SOURCE_LABEL: Record<string, string> = {
  SALARY: "Salary",
  BUSINESS_INCOME: "Business Income",
  GIFT: "Gift",
  ANCESTRAL_PROPERTY: "Ancestral Property",
  RENTAL_INCOME: "Rental Income",
  PRIZE_MONEY: "Prize Money",
  ROYALTY: "Royalty",
  OTHERS: "Others",
};

export const INCOME_SLAB_LABEL: Record<string, string> = {
  BELOW_1_LAKH: "Below ₹1 Lakh",
  ONE_TO_FIVE_LACS: "₹1L – ₹5L",
  FIVE_TO_TEN_LACS: "₹5L – ₹10L",
  TEN_TO_TWENTYFIVE_LACS: "₹10L – ₹25L",
  TWENTYFIVE_LACS_TO_ONE_CRORE: "₹25L – ₹1 Crore",
  ABOVE_ONE_CRORE: "Above ₹1 Crore",
};

export const POLITICAL_EXPOSURE_LABEL: Record<string, string> = {
  YES: "Yes",
  NO: "No",
  RELATIVE: "Relative of PEP",
};

export const NOMINATION_RELATION_LABEL: Record<string, string> = {
  AUNT: "Aunt",
  BROTHER: "Brother",
  DAUGHTER: "Daughter",
  DAUGHTER_IN_LAW: "Daughter-in-law",
  FATHER: "Father",
  FATHER_IN_LAW: "Father-in-law",
  GRANDDAUGHTER: "Granddaughter",
  GRANDSON: "Grandson",
  GRANDFATHER: "Grandfather",
  GRANDMOTHER: "Grandmother",
  HUSBAND: "Husband",
  MOTHER: "Mother",
  MOTHER_IN_LAW: "Mother-in-law",
  NEPHEW: "Nephew",
  NIECE: "Niece",
  FRIEND: "Friend",
  SISTER: "Sister",
  SON: "Son",
  SON_IN_LAW: "Son-in-law",
  UNCLE: "Uncle",
  WIFE: "Wife",
  OTHERS: "Others",
  BROTHER_IN_LAW: "Brother-in-law",
  SISTER_IN_LAW: "Sister-in-law",
  SPOUSE: "Spouse",
};

export const NOMINEE_IDENTIFIER_LABEL: Record<string, string> = {
  PAN_CARD: "PAN Card",
  PASSPORT: "Passport",
  DRIVING_LICENSE: "Driving License",
  AADHAAR: "Aadhaar Card",
};

export const BANK_ACCOUNT_TYPE_LABEL: Record<string, string> = {
  SAVINGS: "Savings",
  CURRENT: "Current",
  NRE: "NRE",
  NRO: "NRO",
};

export const HOLDING_NATURE_LABEL: Record<string, string> = {
  SI: "Single",
  JO: "Joint",
  AS: "Authorized Signatory",
};

export const MANDATE_TYPE_LABEL: Record<string, string> = {
  N: "Net Banking (ENACH)",
  X: "NACH",
  U: "UPI",
};

export const GOAL_CATEGORY_LABEL: Record<string, string> = {
  WEDDING: "Wedding",
  EDUCATION: "Education",
  RETIREMENT: "Retirement",
  DREAM_CAR: "Dream Car",
  DREAM_BIKE: "Dream Bike",
  HOME_RENOVATION: "Home Renovation",
  GROW_YOUR_WEALTH: "Grow Your Wealth",
  BUSINESS_SETUP: "Business Setup",
  EMERGENCY: "Emergency",
  VACATION: "Vacation",
  ELECTRONICS_PURCHASE: "Electronics Purchase",
  CUSTOM: "Custom",
};

export const INVESTMENT_TYPE_LABEL: Record<string, string> = {
  SIP: "SIP",
  LUMPSUM: "Lumpsum",
  SIP_PLUS_LUMPSUM: "SIP + Lumpsum",
};

// ─── Risk profile enum label maps ────────────────────────────────────────────

export const RISK_INVESTMENT_EXPERIENCE_LABEL: Record<string, string> = {
  LESS_THAN_1_YEAR: "Less than 1 year",
  AROUND_1_3_YEARS: "Around 1–3 years",
  AROUND_4_6_YEARS: "Around 4–6 years",
  MORE_THAN_7_YEARS: "More than 7 years",
};

export const RISK_MARKET_FLUCTUATIONS_LABEL: Record<string, string> = {
  SELL_ALL_INVESTMENTS: "Sell all investments",
  SELL_SOME_INVESTMENTS: "Sell some investments",
  DO_NOTHING: "Do nothing",
  BUY_MORE_AT_LOWER_PRICE: "Buy more at lower price",
};

export const RISK_LOSS_TAKING_APPETITE_LABEL: Record<string, string> = {
  NOT_COMFORTABLE_AT_ALL: "Not comfortable at all",
  SLIGHTLY_COMFORTABLE: "Slightly comfortable",
  MODERATELY_COMFORTABLE: "Moderately comfortable",
  VERY_COMFORTABLE: "Very comfortable",
};

export const RISK_PORTFOLIO_DROPS_LABEL: Record<string, string> = {
  MINUS_LT_10_PERCENT: "Less than -10%",
  MINUS_10_25_PERCENT: "-10% to -25%",
  MINUS_25_40_PERCENT: "-25% to -40%",
  MINUS_GT_40_PERCENT: "Greater than -40%",
};

export const RISK_INCOME_STABILITY_LABEL: Record<string, string> = {
  VERY_UNSTABLE: "Very unstable",
  SOMEWHAT_UNSTABLE: "Somewhat unstable",
  STABLE: "Stable",
  VERY_STABLE: "Very stable",
};

export const RISK_EMERGENCY_FUNDS_LABEL: Record<string, string> = {
  LESS_THAN_3_MONTHS: "Less than 3 months",
  AROUND_3_6_MONTHS: "Around 3–6 months",
  AROUND_6_12_MONTHS: "Around 6–12 months",
  MORE_THAN_12_MONTHS: "More than 12 months",
};

export const RISK_FINANCIAL_OBLIGATIONS_LABEL: Record<string, string> = {
  YES_SIGNIFICANT_OBLIGATIONS: "Yes, significant obligations",
  YES_SOME_OBLIGATIONS: "Yes, some obligations",
  FEW_OBLIGATIONS: "Few obligations",
  NO_OBLIGATIONS: "No obligations",
};

export const RISK_CURRENT_INVESTMENTS_LABEL: Record<string, string> = {
  MOSTLY_SAFE: "Mostly safe",
  SOMEWHAT_SAFE_SOME_RISKY: "Somewhat safe, some risky",
  EQUAL_COMBINATION: "Equal combination",
  MOSTLY_RISKY: "Mostly risky",
};

export const RISK_RETURN_EXPECTATIONS_LABEL: Record<string, string> = {
  LESS_THAN_6_PERCENT: "Less than 6%",
  AROUND_6_9_PERCENT: "Around 6–9%",
  AROUND_9_12_PERCENT: "Around 9–12%",
  MORE_THAN_12_PERCENT: "More than 12%",
};

export const RISK_INVESTMENT_GOALS_LABEL: Record<string, string> = {
  WEALTH_PRESERVATION: "Wealth preservation",
  WEALTH_DISTRIBUTION: "Wealth distribution",
  NOMINAL_WEALTH_CREATION: "Nominal wealth creation",
  AGGRESSIVE_WEALTH_CREATION: "Aggressive wealth creation",
};

export const RISK_TIME_HORIZON_LABEL: Record<string, string> = {
  LESS_THAN_3_YEARS: "Less than 3 years",
  AROUND_3_5_YEARS: "Around 3–5 years",
  AROUND_5_10_YEARS: "Around 5–10 years",
  MORE_THAN_10_YEARS: "More than 10 years",
};

export const RISK_TIME_FLEXIBILITY_LABEL: Record<string, string> = {
  NOT_FLEXIBLE_AT_ALL: "Not flexible at all",
  SLIGHTLY_FLEXIBLE: "Slightly flexible",
  SOMEWHAT_FLEXIBLE: "Somewhat flexible",
  VERY_FLEXIBLE: "Very flexible",
};

/** Returns the human-readable label for an enum value, falling back to the raw value. */
export const enumLabel = (map: Record<string, string>, value: string | null | undefined): string | null => {
  if (!value) return null;
  return map[value] ?? value;
};
